<template>
  <div class="actions encart">
        <h2>Liste des actions</h2>
        <form @submit.prevent="submit">
          <select id="motif" v-model="motif" required>
            <option value="Problème de stock">Problème de stock</option>
            <option value="Problème de réception / RNC fournisseur">Problème de réception / RNC fournisseur</option>
            <option v-if="loggedInRole === 'be' || loggedInRole === 'admin'" value="Demande de Modifications Articles">Demande de Modifications Articles</option>
            <option value="Demande d'achat // à commander">Demande d'achat // à commander</option>
            <option value="Autre">Autre</option>
          </select>
          <!-- Remplacement du select du rôle par la liste des emails -->
          <div class="checkbox-group destinataires-group">
            <label class="checkbox-option" v-for="email in destinatairesEmails" :key="email">
              <input type="checkbox" v-model="destinataires" :value="email"> {{ email }}
            </label>
          </div>
          <input type="text" v-if="motif === 'Autre'" v-model="autreMotif" placeholder="Entrez votre motif ici" />
          
          <!-- Zone de dépôt pour les fichiers -->
          <div 
            class="drop-zone-actions"
            :class="{ 'drag-over': isDragOver }"
            @drop="handleDrop"
            @dragover="handleDragOver"
            @dragenter="handleDragEnter"
            @dragleave="handleDragLeave"
            @click="triggerFileInput"
            style="cursor: pointer;"
          >
            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-cloud-upload" viewBox="0 0 16 16">
              <path fill-rule="evenodd" d="M4.406 1.342A5.53 5.53 0 0 1 8 0c2.69 0 4.923 2 5.166 4.579C14.758 4.804 16 6.137 16 7.773 16 9.569 14.502 11 12.687 11H10a.5.5 0 0 1 0-1h2.688C13.979 10 15 8.988 15 7.773c0-1.216-1.02-2.228-2.313-2.228h-.5v-.5C12.188 2.825 10.328 1 8 1a4.53 4.53 0 0 0-3.746 1.996 3.686 3.686 0 0 0 .180 6.741A1.5 1.5 0 0 1 6 11.5a.5.5 0 0 1-1 0 2.5 2.5 0 0 0-.956-1.996 2.686 2.686 0 0 1-.004-5.162z"/>
              <path fill-rule="evenodd" d="M7.646 4.146a.5.5 0 0 1 .708 0l3 3a.5.5 0 0 1-.708.708L8.5 5.707V14.5a.5.5 0 0 1-1 0V5.707L5.354 7.854a.5.5 0 1 1-.708-.708l3-3z"/>
            </svg>
            Glissez ou <span class="file-label">cliquez ici</span> pour ajouter des fichiers
            <input
              type="file"
              ref="fileInput"
              multiple
              style="display: none"
              @change="addFichiers"
            />
          </div>
          
          <!-- Affichage des fichiers sélectionnés -->
          <div v-if="fichiers.length > 0" class="selected-files">
            <p>Fichiers sélectionnés :</p>
            <ul>
              <li v-for="(file, index) in fichiers" :key="index">
                {{ file.name }}
                <button type="button" @click="removeFile(index)" class="remove-file">×</button>
              </li>
            </ul>
          </div>

          <textarea id="commentaire_motif" rows="5" v-model="commentaire_motif" placeholder="Entrez votre commentaire ici"></textarea>
          
          <button type="submit"><svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-send-fill" viewBox="0 0 16 16">
          <path d="M15.964.686a.5.5 0 0 0-.65-.65L.767 5.855H.766l-.452.18a.5.5 0 0 0-.082.887l.41.26.001.002 4.995 3.178 3.178 4.995.002.002.26.41a.5.5 0 0 0 .886-.083l6-15Zm-1.833 1.89L6.637 10.07l-.215-.338a.5.5 0 0 0-.154-.154l-.338-.215 7.494-7.494 1.178-.471-.47 1.178Z"/>
          </svg>Envoyer ma demande</button>

          <div v-if="confirmationMessage" class="alert alert-success" role="alert">
            {{ confirmationMessage }}
          </div>
          <div v-if="errorMessage" class="alert alert-danger" role="alert">
            {{ errorMessage }}
          </div>
        </form>
  </div>
</template>

<script>
import axios from '@/components/axiosConfig.js'
import VueCookies from 'vue-cookies'
import { processFile } from '@/mixins/imageCompressionMixin.js'

export default {
  data() {
    return {
      infos: [],
      codeArticle: '',
      motif: 'Problème de stock',
      confirmationMessage: '',
      errorMessage: '',
      utilisateur: '',
      autreMotif: '',
      commentaire_motif: '',
      loggedInRole: null,
      // userRole: 'gestion', // supprimé car remplacé par destinataires
      fichiers: [],
      isDragOver: false,
      destinatairesEmails: [], // Ajouté
      destinataires: [], // Ajouté
    }
  },
  created() {
    this.codeArticle = this.$route.params.codeArticle;

  
  },
  mounted() { 
    
    const nom = VueCookies.get('nom')
    if (nom) {
        this.utilisateur = nom
    }
    const prenom = VueCookies.get('prenom')
    if (prenom) {
      this.utilisateur += " " + prenom;
    }
    axios.post('https://www.simef.fr/espace-client/api/getInternUtilisateurs.php')
      .then(response => {
        this.destinatairesEmails = response.data;
      })
      .catch(error => {
        console.error('Erreur lors de la récupération des emails internes:', error);
      });
  }, 
  methods: {
    handleDragOver(event) {
      event.preventDefault();
      event.dataTransfer.dropEffect = 'copy';
    },
    
    handleDragEnter(event) {
      event.preventDefault();
      this.isDragOver = true;
    },
    
    handleDragLeave(event) {
      event.preventDefault();
      if (!event.currentTarget.contains(event.relatedTarget)) {
        this.isDragOver = false;
      }
    },
    
    async handleDrop(event) {
      event.preventDefault();
      this.isDragOver = false;
      
      const files = event.dataTransfer.files;
      for (let i = 0; i < files.length; i++) {
        const processedFile = await processFile(files[i]);
        this.fichiers.push(processedFile);
      }
    },

    async addFichiers(event) {
      const files = event.target.files;
      for (let i = 0; i < files.length; i++) {
        const processedFile = await processFile(files[i]);
        this.fichiers.push(processedFile);
      }
    },

    removeFile(index) {
      this.fichiers.splice(index, 1);
    },

    formatDate(date) {
      // Extraire les parties de la date
      const year = date.substr(0, 4);
      const month = date.substr(4, 2);
      const day = date.substr(6, 2);

      // Concaténer les parties dans l'ordre souhaité
      const formattedDate = `${day}-${month}-${year}`;

      // Renvoyer la date formatée
      return formattedDate;
    },
    submit() {
      // Créer un objet FormData
      let formData = new FormData();

      // Ajouter les données du formulaire à FormData
      formData.append('motif', this.motif);
      formData.append('autreMotif', this.autreMotif);
      formData.append('utilisateur', this.utilisateur);
      formData.append('codeArticle', this.codeArticle);
      // formData.append('userRole', this.userRole); // supprimé
      formData.append('commentaire_motif', this.commentaire_motif);
      formData.append('destinataires', JSON.stringify(this.destinataires)); // Ajouté

      // Ajouter les fichiers à FormData
      for (let i = 0; i < this.fichiers.length; i++) {
        formData.append('fichiers[]', this.fichiers[i]);
      }

      // Envoyer les données du formulaire au serveur
      axios.post('https://www.simef.fr/espace-client/api/ajoutDemandes.php', formData, {
          headers: {
            'Content-Type': 'multipart/form-data'
          }
      })
      .then(response => {
          // Réinitialiser les champs du formulaire
          this.motif = 'Problème de stock';
          // this.userRole = 'gestion'; // supprimé
          this.autreMotif = '';
          this.commentaire_motif = '';
          this.fichiers = []; // Réinitialiser les fichiers après l'envoi
          // Afficher le message de succès
          this.confirmationMessage = response.data.success;
          this.errorMessage = response.data.error;
      })
      .catch(error => {
          console.error(error);
          this.refusMessage = "Une erreur est survenue";
      });
    },
    triggerFileInput() {
      this.$refs.fileInput.click();
    },
  }

  
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
  $primary: #2b358d;
  h2 {
    text-align: left;
  }
  h3 {
    font-size: 1.2rem;
    text-transform: uppercase!important;
  }
  .actions, .com {
    input {
      margin-top: 10px;
    }
    textarea {
      width: 100%;
      background: #fff;
      border: 0px;
      padding: 10px;
      margin-top: 10px;
    }
  }

    form {
      margin-top: 15px;
      select, input {
        background: #f5f5f5;
        border: 0px;
        padding: 12px 20px;
        border: 1px solid lightgrey;
        margin-right: 10px;
        width: 100%;
      }
   
      button {
        margin-top: 15px;
        svg {
          margin-right: 15px;
        }
      }
    }

  .drop-zone-actions {
    border: 2px dashed #ccc;
    border-radius: 4px;
    padding: 20px;
    margin: 10px 0;
    text-align: center;
    transition: all 0.3s ease;
    cursor: pointer;
    background-color: #f9f9f9;
    
    &.drag-over {
      border-color: $primary;
      background-color: rgba($primary, 0.1);
      
      svg {
        color: $primary;
      }
    }
    
    svg {
      margin-right: 5px;
      color: #666;
    }
    
    .file-label {
      color: $primary;
      text-decoration: underline;
      cursor: pointer;
      
      &:hover {
        color: darken($primary, 10%);
      }
    }
  }

  .selected-files {
    margin: 10px 0;
    
    p {
      font-weight: bold;
      margin-bottom: 5px;
    }
    
    ul {
      list-style: none;
      padding: 0;
      
      li {
        background-color: #f5f5f5;
        padding: 5px 10px;
        margin: 2px 0;
        border-radius: 3px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        
        .remove-file {
          background: none;
          border: none;
          color: #999;
          cursor: pointer;
          font-size: 18px;
          padding: 0;
          margin: 0;
          
          &:hover {
            color: #333;
          }
        }
      }
    }
  }

  .checkbox-group.destinataires-group {
    display: flex;
    flex-wrap: wrap;
    gap: 5px;
    margin-top: 8px;
    align-items: center;
    width: 100%;
    min-width: 260px;
    background: #f7f7f7;
    padding: 8px;
    border-radius: 0px;
    border: 1px solid #d4d4d4;
  }
  .checkbox-option {
    display: flex;
    align-items: center;
    gap: 5px;
    width: 49%;
    background: #f7f7f7;
    border-radius: 0;
    font-weight: 500;
    cursor: pointer;
    input[type="checkbox"] {
      accent-color: $primary;
      width: initial;
      margin: 0 !important;
    }
    &:hover {
      background: #e6eaf3;
    }
  }

</style>
